var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Collection"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.667 9.16667H3.33366M16.667 9.16667C17.5875 9.16667 18.3337 9.91283 18.3337 10.8333V14.1667C18.3337 16.0076 16.8412 17.5 15.0003 17.5H5.00033C3.15938 17.5 1.66699 16.0076 1.66699 14.1667V10.8333C1.66699 9.91283 2.41318 9.16667 3.33366 9.16667M16.667 9.16667V7.5C16.667 6.57952 15.9208 5.83333 15.0003 5.83333M3.33366 9.16667V7.5C3.33366 6.57952 4.07985 5.83333 5.00033 5.83333M15.0003 5.83333H5.00033M15.0003 5.83333V4.16667C15.0003 3.24619 14.2542 2.5 13.3337 2.5H6.66699C5.74652 2.5 5.00033 3.24619 5.00033 4.16667V5.83333M8.33366 11.6667H11.667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollection);
export default __webpack_public_path__ + "static/media/collection.4f6918f1343d08fcdbbb0794f05b7a3a.svg";
export { ForwardRef as ReactComponent };